
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const LearnPage = lazy(() => import('../pages/learn/page'));
const LessonsPage = lazy(() => import('../pages/lessons/page'));
const ProgressPage = lazy(() => import('../pages/progress/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/learn',
    element: <LearnPage />,
  },
  {
    path: '/lessons',
    element: <LessonsPage />,
  },
  {
    path: '/progress',
    element: <ProgressPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
